import {User} from "./user";
import {Build} from "./build";

export interface SupportTicket {
    id: string,
    user: User,
    title: string,
    description: string,
    ticket_status: string,
    build?: Build,
    created_at?: string,
    updated_at?: string,
    ticket_link?: string,
}

export const SupportTicketStatusList = [
    {label: "Open", value: "open"},
    {label: "In Progress", value: "in_progress"},
    {label: "Resolved", value: "resolved"},
    {label: "Rejected", value: "rejected"},
]

export interface FeatureRequest {
    id: string,
    user?: User,
    title: string,
    description: string,
    created_at?: string,
    updated_at?: string,
    request_status: string,
    ticket_link?: string,
    anonymous: boolean
}

export const FeatureRequestStatusList = [
    {label: "Open", value: "open"},
    {label: "Under Review", value: "under_review"},
    {label: "Closed", value: "closed"},
]

